import {getLeadService} from "./index";
import {useAuthenticatedQuery} from "../../components/_shared/hooks/useAuthenticatedQuery";

const fetchLeadBy = async (): Promise<boolean> => {
  try {
    return getLeadService().then(async (service) => {
      return service.getLeadExists().then((response) => {
        return response;
      });
    });
  } catch (error) {
    console.error("LeadServiceError", error);
    return true;
  }
};

const useLeadExists = (auth_user_id?: string) => {
  const {
    data: nexus_lead_exists,
    refetch,
    isFetching,
  } = useAuthenticatedQuery<boolean>({
    queryKey: ["lead-exists", auth_user_id],
    queryFn: fetchLeadBy,
    cacheTime: 0,
    enabled: !!auth_user_id, // Additional check on top of useAuthenticatedQuery's auth checks
  });
  return {
    data: nexus_lead_exists,
    refetch: refetch,
    isFetching: isFetching,
  };
};

export default useLeadExists;
